import React from 'react';

export const getInitial = (name) => {
    return typeof name === 'string' ? name.charAt(0).toUpperCase() : null;
};

export function AvatarName({firstName, lastName}) {
    if (!firstName || !firstName.length) {
        return null;
    }
    let lastInitial = getInitial(lastName);
    lastInitial = lastInitial ? `${lastInitial}.` : '';
    return <strong className="avatar__name">{`${firstName} ${lastInitial}`}</strong>;
}

export function Initials({
    firstName,
    lastName,
    sm = false
}) {
    const first = getInitial(firstName);
    if (!first) {
        return null;
    }
    if (sm) {
        return first;
    }
    const last = getInitial(lastName);
    return `${first}${last ? last : ''}`;
}

Initials.defaultProps = {
    sm: false
};

export default AvatarName;


// WEBPACK FOOTER //
// ./src/universal/tripboard/avatar/avatar-name.js